import React from "react";
import { styled } from "@mui/material/styles";

const DividerBase = styled("div")(({ theme }) => ({
  height: "1px",
  margin: theme.spacing(2.5, "auto")
}));

const DividerDark = styled(DividerBase)(({ theme }) => ({
  backgroundColor: theme.palette.grey[400]
}));

const DividerLight = styled(DividerBase)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300]
}));

/**
 * Divider component for separating content sections
 */
const Divider = {
  /**
   * Renders a dark divider with gray color
   * @param {object} props
   * @returns {React.ReactElement} Dark divider component
   */
  Dark: props => <DividerDark {...props} />,

  /**
   * Renders a light divider with light gray color
   * @param {object} props
   * @returns {React.ReactElement} Light divider component
   */
  Light: props => <DividerLight {...props} />
};

export { Divider };
